// extracted by mini-css-extract-plugin
export default {"container":"SocialSharing_container__d-foj","sharingOptions":"SocialSharing_sharingOptions__q5y+f","isFixed":"SocialSharing_isFixed__BFibz"};